import { useRoutes } from 'react-router-dom'
import { useAuth } from '../auth'
import { publicRoutes } from './publicRoutes'
import { protectedRoutes } from './protectedRoutes'
// import { protectedRoutes } from './protectedRoutes'

const AppRoutes = () => {
  const { user } = useAuth()
  const routes = user ? protectedRoutes(user.role) : publicRoutes
  const app = useRoutes(routes)
  return app
}

export default AppRoutes
